import type { DartInput } from "./types";

interface CheckoutDart extends DartInput {
  value: number;
}

const singles: CheckoutDart[] = Array.from({ length: 20 }, (_, index) => {
  const n = 20 - index;
  return { segment: n, multiplier: 1, value: n, label: `S${n}` };
});
const doubles: CheckoutDart[] = Array.from({ length: 20 }, (_, index) => {
  const n = 20 - index;
  return { segment: n, multiplier: 2, value: n * 2, label: `D${n}` };
});
const triples: CheckoutDart[] = Array.from({ length: 20 }, (_, index) => {
  const n = 20 - index;
  return { segment: n, multiplier: 3, value: n * 3, label: `T${n}` };
});

const bull: CheckoutDart = { segment: 25, multiplier: 2, value: 50, label: "BULL" };
const outerBull: CheckoutDart = { segment: 25, multiplier: 1, value: 25, label: "25" };
const scoring = [...triples, ...doubles, ...singles, bull, outerBull];
const finishing = [bull, ...doubles];

export function checkoutSuggestion(
  score: number,
  dartsLeft: number,
  doubleOut: boolean,
): string[] {
  if (score <= 0 || dartsLeft <= 0 || score > 180) return [];
  const finalDarts = doubleOut ? finishing : scoring;

  for (let length = 1; length <= Math.min(3, dartsLeft); length += 1) {
    const search = (remaining: number, depth: number, path: CheckoutDart[]): CheckoutDart[] | null => {
      if (depth === length - 1) {
        return finalDarts.find((dart) => dart.value === remaining)
          ? [...path, finalDarts.find((dart) => dart.value === remaining)!]
          : null;
      }
      for (const dart of scoring) {
        if (dart.value >= remaining) continue;
        const result = search(remaining - dart.value, depth + 1, [...path, dart]);
        if (result) return result;
      }
      return null;
    };
    const result = search(score, 0, []);
    if (result) return result.map((dart) => dart.label);
  }
  return [];
}
